<template>
  <v-col cols="12" class="px-0">
    <v-list class="py-0 inspections-list" dense>
      <v-list-item
        v-for="(inspection, idx) in items"
        :key="idx"
        class="inspection-element hover-list-element px-2"
        @click="openInspection(getArrayValue(inspection, idKeyPath))"
      >
        <v-list-item-content>
          <v-list-item-title :title="getArrayValue(inspection, nameKeyPath)" class="text-body-2">
            <v-row no-gutters align="center">
              <v-col cols="auto" class="px-1">
                <div class="text-body-2 inspections-list-text">
                  {{ $dayjs(getArrayValue(inspection, dateKeyPath)).format(localeDateFormat) }}
                </div>
              </v-col>
              <v-col cols="auto" v-if="users[getArrayValue(inspection, userKeyPath)]">
                <v-subheader
                  class="text-caption font-italic px-0"
                  style="height: auto;"
                  v-text="
                    `(${
                      users[getArrayValue(inspection, userKeyPath)]
                        ? users[getArrayValue(inspection, userKeyPath)].name
                        : ''
                    })`
                  "
                />
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>
<script>
import { get } from 'vuex-pathify';
import { get as lodashGet } from 'lodash';

export default {
  name: 'InspectionsList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    localeDateFormat: {
      validatior: value => {
        return ['ll', 'l', 'LL', 'L'].indexOf(value) !== -1;
      },
      default: 'L',
    },
    idKeyPath: {
      type: String,
      default: 'id',
    },
    userKeyPath: {
      type: String,
      default: 'user_carried_out',
    },
    dateKeyPath: {
      type: String,
      default: 'date_carried_out',
    },
    nameKeyPath: {
      type: String,
      default: 'name',
    },
  },
  computed: {
    users: get('users/users'),
  },
  methods: {
    openInspection(id) {
      this.$emit('openInspection', id);
    },
    getArrayValue(array = [], path = '') {
      return lodashGet(array, path);
    },
  },
};
</script>
<style lang="scss" scoped>
.inspection-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.inspections-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.inspections-list-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
